import { type ReactNode } from 'react'

interface CardProps {
  children: ReactNode
  className?: string
}

export const Card = ({ children, className = '' }: CardProps) => {
  return (
    <div className={`bg-card rounded-lg border border-border shadow-sm ${className}`}>
      {children}
    </div>
  )
}